// eslint-disable-next-line max-classes-per-file
import React, { Component } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';
import { tr } from '../utils/locale';
import Icon from '../Icon/Icon';
import Tooltip from '../Tooltip/Tooltip';

import localitiesImg from '../../images/products/product-localities.png';
import localitiesUkImg from '../../images/products/product-localities-uk.png';
import geolocationImg from '../../images/products/product-geolocation.png';
import storesImg from '../../images/products/product-stores.png';
import distanceImg from '../../images/products/product-distance.png';
import addressImg from '../../images/products/product-address.png';
import mapImg from '../../images/products/product-map.png';
import trafficImg from '../../images/products/product-traffic.png';
import merchantImg from '../../images/products/product-merchant.png';
import indoorImg from '../../images/products/product-indoor.png';
import what3wordsImg from '../../images/products/product-what3words.png';
import transitImg from '../../images/products/product-transit.png';

import localitiesImgSq from '../../images/products/product-localities-sq.png';
import localitiesUkImgSq from '../../images/products/product-localities-uk-sq.png';
import geolocationImgSq from '../../images/products/product-geolocation-sq.png';
import storesImgSq from '../../images/products/product-stores-sq.png';
import distanceImgSq from '../../images/products/product-distance-sq.png';
import addressImgSq from '../../images/products/product-address-sq.png';
import mapImgSq from '../../images/products/product-map-sq.png';
import trafficImgSq from '../../images/products/product-traffic-sq.png';
import merchantImgSq from '../../images/products/product-merchant-sq.png';
import indoorImgSq from '../../images/products/product-indoor-sq.png';
import what3wordsImgSq from '../../images/products/product-what3words-sq.png';
import transitImgSq from '../../images/products/product-transit-sq.png';

const productImg = {
    LOCALITIES: localitiesImg,
    LOCALITIES_ADDRESS_UK: localitiesUkImg,
    GEOLOCATION: geolocationImg,
    STORES: storesImg,
    DISTANCE: distanceImg,
    ADDRESS: addressImg,
    MAP: mapImg,
    TRAFFIC: trafficImg,
    MERCHANTS: merchantImg,
    INDOOR: indoorImg,
    W3W: what3wordsImg,
    TRANSIT: transitImg,
};
const productImgSq = {
    LOCALITIES: localitiesImgSq,
    LOCALITIES_ADDRESS_UK: localitiesUkImgSq,
    GEOLOCATION: geolocationImgSq,
    STORES: storesImgSq,
    DISTANCE: distanceImgSq,
    ADDRESS: addressImgSq,
    MAP: mapImgSq,
    TRAFFIC: trafficImgSq,
    MERCHANTS: merchantImgSq,
    INDOOR: indoorImgSq,
    W3W: what3wordsImgSq,
    TRANSIT: transitImgSq,
};

class Header extends Component {
    render() {
        const { children, ...rest } = this.props;
        return (
            <div className={cl('card__header')} {...rest}>
                {children}
            </div>
        );
    }
}

Header.propTypes = {
    children: PropTypes.node.isRequired,
};

class Body extends Component {
    render() {
        const { children, ...rest } = this.props;
        return (
            <div className={cl('card__body')} {...rest}>
                {children}
            </div>
        );
    }
}

Body.propTypes = {
    children: PropTypes.node.isRequired,
};

class Footer extends Component {
    render() {
        const { children, ...rest } = this.props;
        return (
            <div className={cl('card__footer')} {...rest}>
                {children}
            </div>
        );
    }
}

Footer.propTypes = {
    children: PropTypes.node.isRequired,
};

class Aside extends Component {
    render() {
        const { product, mode, children, isEnterprise } = this.props;
        if (mode === 'pluggedTo') {
            return (
                <div className="card__aside card__aside--small card__aside--grey">
                    <div className="card__aside__title">{tr('Plugged to')}</div>
                    <ul className="card__aside__list">
                        <li className="card__aside__list__item">
                            <img
                                className="card__aside__list__item__image"
                                src={productImgSq[product.id]}
                                alt={product.name}
                            />
                            <span className="card__aside__list__item__title">{product.name}</span>
                        </li>
                    </ul>
                </div>
            );
        }
        if (mode === 'addon') {
            return (
                <div className="card__aside card__aside--addon">
                    <div className="card__aside__title">{tr('Addon')}</div>
                    <ul className="card__aside__list">
                        <li className="card__aside__list__item">
                            <img
                                className="card__aside__list__item__image"
                                src={productImgSq[product.id]}
                                alt={product.name}
                            />
                            <div className="card__aside__list__item__section">
                                <div className="card__aside__list__item__section__title">{product.name}</div>
                                {!isEnterprise ? (
                                    <Tooltip
                                        direction="n"
                                        wrap
                                        text={tr(
                                            '{{name}} add-on not included in the 40k Free credits/month. Usage is chargeable from the first request.',
                                            { name: product.name }
                                        )}
                                    >
                                        <div className="card__aside__list__item__section__paying-label">
                                            <span>{tr('Paying from the first request')}</span>
                                        </div>
                                    </Tooltip>
                                ) : (
                                    false
                                )}
                                <div className="card__aside__list__item__section__item">{children}</div>
                            </div>
                        </li>
                    </ul>
                </div>
            );
        }
        return (
            <div className="card__aside">
                <div className="card__aside__title">{tr('Work with')}</div>
                <ul className="card__aside__list">
                    <li className="card__aside__list__item">
                        <img
                            className="card__aside__list__item__image"
                            src={productImgSq[product.id]}
                            alt={product.name}
                        />
                        <span className="card__aside__list__item__title">{product.name}</span>
                    </li>
                </ul>
                <div className="card__aside__footer">Will be automatically activated</div>
            </div>
        );
    }
}

Aside.propTypes = {
    children: PropTypes.node,
    product: PropTypes.object.isRequired,
    isEnterprise: PropTypes.bool,

    mode: PropTypes.oneOf(['pluggedTo', 'addon', 'worksWith']).isRequired,
};

Aside.defaultProps = {
    children: null,
    isEnterprise: false,
};

class Card extends Component {
    render() {
        const {
            isList,
            noBorder,
            isClickable,
            product,
            iconSize,
            children,
            className,
            active,
            onClick,
            useIcon,
            size,
            testId,
            isNew,
            isVertical,
            asideContent,
            ...rest
        } = this.props;

        const itemClass = useIcon ? 'card__icon' : 'card__image';
        let imgSize = size;
        switch (imgSize) {
            case 'normal':
                imgSize = productImg[product];
                break;
            case 'small':
                imgSize = productImgSq[product];
                break;
            case 'large':
                imgSize = productImg[product];
                break;
            default:
                imgSize = productImg[product];
        }
        const cardContent = (
            <>
                <div className={itemClass}>
                    {useIcon ? (
                        <Icon icon={product.toLowerCase()} size={iconSize} alt={product} />
                    ) : (
                        <img className="card__img" src={imgSize} alt={product} />
                    )}
                    {isNew && !isList ? <div className="card__new-label">{tr('New')}</div> : null}
                </div>
                <div className="card__content">
                    {isNew && isList ? <div className="card__new-label">{tr('New')}</div> : null}
                    {children}
                </div>
            </>
        );
        return (
            <div
                role="button"
                className={cl(
                    'card',
                    { 'card--vertical': isVertical },
                    `card--${size}`,
                    { 'card--aside': asideContent },
                    { 'card--no-border': noBorder },
                    { 'card--clickable': isClickable },
                    `card--${product.toLowerCase()}`,
                    className,
                    { active },
                    { 'card--list': isList }
                )}
                {...rest}
                onClick={onClick}
                onKeyDown={onClick}
                tabIndex="0"
                data-testid={testId}
            >
                {asideContent ? (
                    <>
                        <div className="card__wrapper">{cardContent}</div>
                        {asideContent}
                    </>
                ) : (
                    cardContent
                )}
            </div>
        );
    }
}

Card.defaultProps = {
    asideContent: null,
    size: 'normal',
    isVertical: false,
    useIcon: false,
    isList: false,
    className: null,
    active: false,
    onClick: null,
    product: null,
    iconSize: 36,
    isClickable: false,
    noBorder: false,
    isNew: false,
    testId: 'card',
};

Card.propTypes = {
    asideContent: PropTypes.node,
    size: PropTypes.oneOf(['small', 'large', 'normal']),
    isVertical: PropTypes.bool,
    testId: PropTypes.string,
    children: PropTypes.node.isRequired,
    useIcon: PropTypes.bool,
    className: PropTypes.string,
    isList: PropTypes.bool,
    active: PropTypes.bool,
    onClick: PropTypes.func,
    product: PropTypes.oneOf([
        'LOCALITIES',
        'LOCALITIES_ADDRESS_UK',
        'GEOLOCATION',
        'STORES',
        'DISTANCE',
        'ADDRESS',
        'MAP',
        'TRAFFIC',
        'MERCHANTS',
        'LOCALITIES',
        'INDOOR',
        'W3W',
    ]),
    iconSize: PropTypes.number,
    isClickable: PropTypes.bool,
    noBorder: PropTypes.bool,
    isNew: PropTypes.bool,
};

export default Object.assign(Card, {
    Header,
    Body,
    Footer,
    Aside,
});
